module.exports = __webpack_public_path__ + "img/bank-transfer.8fe8479f.svg";